import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { firstValueFrom, Observable } from 'rxjs';
import { HttpService } from '../core/http.service';
import { environment } from '@base/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ChangeCurrencyService extends HttpService {
  constructor(public override http: HttpClient) {
    super(http);
    this.url = '/configuration/user/changeCurrency/';
    this.baseUrl = environment.apiEndpoint;
  }

  async postNoId(body: Record<string, any>): Promise<HttpResponse<any>> {
    const response = await firstValueFrom(this.postNoIdObservable(body));
    return response;
  }

  postNoIdObservable(body: Record<string, any>): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(this.baseUrl + this.url, body, {
      responseType: 'json',
      observe: 'response',
    });
  }
}
